import _ from 'lodash';
import * as RequestResultCases from 'middlewares/api-middleware';
import { SEARCH_COMMS_TRACE } from 'omega-rtc/actions/debugging-tools';
import type { CommsTraceJourney } from 'omega-rtc/views/debugging-tools/types';

export type DebuggingToolsState = {
  journeys: CommsTraceJourney[];
  total: number;
  truncated: boolean;
  timezone: string;
  hasSearched: boolean;
  notConfigured: boolean;
  lastRequestId: number;
};

export const defaultDebuggingToolsState: DebuggingToolsState = {
  journeys: [],
  total: 0,
  truncated: false,
  timezone: 'UTC',
  hasSearched: false,
  notConfigured: false,
  lastRequestId: 0,
};

const requestIdOf = (action: any): number => _.get(action, 'meta.requestId', 0);

const debuggingToolsReducer = (
  state: DebuggingToolsState = defaultDebuggingToolsState,
  action: any,
): DebuggingToolsState => {
  switch (action.type) {
    case SEARCH_COMMS_TRACE + RequestResultCases.REQUEST:
      return {
        ...state,
        journeys: [],
        total: 0,
        truncated: false,
        notConfigured: false,
        lastRequestId: requestIdOf(action),
      };
    case SEARCH_COMMS_TRACE + RequestResultCases.SUCCESS:
      if (requestIdOf(action) < state.lastRequestId) return state;
      return {
        ...state,
        journeys: _.get(action.payload, 'journeys') || [],
        total: _.get(action.payload, 'total') || 0,
        truncated: Boolean(_.get(action.payload, 'truncated')),
        timezone: _.get(action.payload, 'timezone') || 'UTC',
        notConfigured: false,
        hasSearched: true,
      };
    case SEARCH_COMMS_TRACE + RequestResultCases.FAILURE:
      if (requestIdOf(action) < state.lastRequestId) return state;
      return {
        ...state,
        journeys: [],
        total: 0,
        truncated: false,
        notConfigured: Boolean(_.get(action, 'meta.notConfigured')),
        hasSearched: true,
      };
    default:
      return state;
  }
};

export default debuggingToolsReducer;
